import Vue from 'vue';
import format from 'date-fns/format';

export const clientsListingService = {
  async getClientsList(
    paginationParameters,
    sortingParameters,
    clientsFilterPreference,
    clientsTypeFilterPreference
  ) {
    return Vue.axios
      .get('/clients', {
        params: {
          ...paginationParameters,
          ...sortingParameters,
          clientsFilterPreference,
          clientsTypeFilterPreference
        }
      })
      .then(response => response.data);
  },

  async getFilteredClientsCount(clientsFilterPreference, clientsTypeFilterPreference, searchParam) {
    return Vue.axios
      .get('/clients/count-records', {
        params: {
          clientsFilterPreference,
          clientsTypeFilterPreference,
          searchParam
        }
      })
      .then(response => response.data);
  },

  async downloadClientsXlsx(
    paginationParameters,
    sortingParameters,
    clientsFilterPreference,
    clientsTypeFilterPreference,
    searchParam
  ) {
    const response = await Vue.axios({
      url: `/clients/xlsx`,
      method: 'GET',
      params: {
        ...paginationParameters,
        ...sortingParameters,
        clientsFilterPreference,
        clientsTypeFilterPreference,
        searchParam
      },
      responseType: 'blob'
    });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `Clients-${format(new Date(), 'YYYY-MM-DD-HH-mm-ss')}.xlsx`);
    document.body.appendChild(link);
    link.click();
  }
};
